import { Stack, Typography } from '@mui/material';
import type { SessionDto } from '@/types/dtos/sessions/session.dto.ts';
import { useTranslations } from '@/i18n/use-translations.tsx';

export const SessionDetails = ({ session }: { session: SessionDto }) => {
  const t = useTranslations();
  return (
    <Stack direction="column">
      <Typography variant="body2">{session.title}</Typography>
      <Typography variant="body2" sx={{ fontWeight: 300 }} color="text.secondary">
        {t(`session.types.${session.type}`)}
      </Typography>
    </Stack>
  );
};
